// First screen which we will use to send the data
import React, { Component } from "react";
//import react in our code.
import {
  Alert,
  SectionList,
  View,
  StyleSheet,
  TouchableOpacity,
  TouchableHighlight,
  FlatList,
  ScrollView,
  Image,
} from "react-native";
import {
  Container,
  Header,
  Button,
  Content,
  List,
  ListItem,
  Left,
  Body,
  Right,
  Thumbnail,
  Text,
  Title,
  Footer,
} from "native-base";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";
//import all the components we are going to use.

import { Constant, MyCart } from "./Data.js";

import { MenuItemModal } from "./MenuItemModal.js";
import { AssistModal } from "./AssistModal.js";

import * as firebase from "firebase";
import "firebase/firestore";

import { GetRestaurant } from "./MenuFetcher";
import { BellOutlined } from "@ant-design/icons";

const firebaseConfig = {
  apiKey: "AIzaSyDaeu9mbyaZEUAiMUWIEiSu5cStW--Ga8g",
  authDomain: "flyby-nyc20.firebaseapp.com",
  databaseURL: "https://flyby-nyc20.firebaseio.com",
  projectId: "flyby-nyc20",
  storageBucket: "flyby-nyc20.appspot.com",
  messagingSenderId: "479082390845",
  appId: "1:479082390845:web:6a04b019caa0b06bd11154",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

export default class HomeScreen extends Component {
  constructor(props) {
    //constructor to set default state
    super(props);
    this.state = {
      restaurantID: props.route.params.id,
      tableID: props.route.params.number,
      menuArray: [],
      stripeID: undefined,
      name: undefined,
      myCart: MyCart.shared.getCartItems(),
      menuItemModal: undefined,
      assistModal: undefined,
    };

    this.props.navigation.setOptions({
      headerRight: (props) => (
        <BellOutlined
          onClick={() => this.showAssistModal()}
          {...props}
          style={{ fontSize: 24, marginRight: 16, color: Constant.color1 }}
        />
      ),
    });

    this.props.navigation.addListener("focus", () => {
      const items = MyCart.shared.getCartItems();
      this.setState({ myCart: items });
    });
  }

  showAssistModal = () => {
    if (this.assistModal) {
      this.assistModal.openModal();
    }
  };

  showMenuItemModal = (item) => {
    if (this.menuItemModal) {
      this.menuItemModal.state.item = item;
      this.menuItemModal.openModal();
    }
  };

  componentDidMount() {
    GetRestaurant(this.state.restaurantID).then((obj) => {
      if (obj) {
        this.setState({
          menuArray: obj.menuArray,
          name: obj.name,
          stripeID: obj.stripeID,
        });
        const tableID = this.state.tableID;
        const screenTitle = obj.name + " - " + "Table " + tableID;
        this.props.navigation.setOptions({ title: screenTitle });
      }
    });
  }

  onAddToCart = (item) => {
    MyCart.shared.pushToCart(item);
    this.setState({ myCart: MyCart.shared.getCartItems() });
    // var joined = this.state.myCart.concat(item);
    // this.setState({ myCart: joined });
  };

  viewCartButtonTapped = () => {
    if (this.state.stripeID && this.state.name) {
      this.props.navigation.navigate("Order", {
        myCart: this.state.myCart,
        stripeID: this.state.stripeID,
        name: this.state.name,
        restaurantID: this.state.restaurantID,
        tableID: this.state.tableID,
      });
    } else {
      return;
    }
  };

  renderListItem = (item) => (
    <ListItem
      button
      onPress={() => {
        this.showMenuItemModal(item);
      }}
    >
      <Body>
        <Text style={styles.itemTitle}>{item.title}</Text>
        <Text style={styles.itemDescription}>{item.description}</Text>
      </Body>
      <Right>
        <Text style={styles.itemPrice}>${item.price}</Text>
      </Right>
    </ListItem>
  );
  renderListHeader = (title) => {
    <Text style={styles.categoryTitle}>{title}</Text>;
  };

  render() {
    return (
      <View
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          backgroundColor: Constant.backgroundColor,
        }}
      >
        <MenuItemModal
          item={{ title: "loading", description: "loading", price: "" }}
          ref={(ref) => {
            this.menuItemModal = ref;
          }}
          onAddToCart={this.onAddToCart}
        />
        <AssistModal
          ref={(ref) => {
            this.assistModal = ref;
          }}
          restaurantID={this.state.restaurantID}
          tableID={this.state.tableID}
        />
        <View style={{ flex: 1 }}>
          <View style={{ flex: 9 }}>
            <SectionList
              initialNumToRender={12}
              sections={this.state.menuArray}
              keyExtractor={(item, index) => item + index}
              renderItem={({ item }) => this.renderListItem(item)}
              renderSectionHeader={({ section: { title } }) => (
                <Text style={styles.categoryTitle}>{title}</Text>
              )}
            />
          </View>
          <View style={{ flexBasis: 76, flexGrow: 0, flexShrink: 0 }}>
            <View
              style={{
                flex: 1,
                marginLeft: 16,
                marginRight: 16,
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <Button
                style={styles.viewCartButton}
                onPress={() => this.viewCartButtonTapped()}
              >
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text style={styles.viewCartButtonText}>View Order</Text>
                  <Text style={styles.viewCartButtonText}>
                    {this.state.myCart.length}
                  </Text>
                </View>
              </Button>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  screen: {
    // backgroundColor: "white"
    flex: 1,
  },
  categoryTitle: {
    marginTop: 32,
    marginBottom: 16,
    fontSize: 20,
    fontFamily: Constant.font,
    fontWeight: "600",
    textAlign: "center",
  },
  itemTitle: {
    fontSize: 18,
    fontFamily: Constant.font,
    fontWeight: "bold",
  },
  itemPrice: {
    fontSize: 18,
    fontFamily: Constant.font,
    fontWeight: "bold",
    // fontStyle: "italic",
    // color: "gray",
  },
  itemDescription: {
    fontSize: 15,
    fontWeight: "400",
    fontStyle: "italic",
    fontFamily: Constant.font,
    color: "gray",
    marginTop: 6,
  },
  viewCartButton: {
    alignItems: "center",
    fontWeight: "bold",
    backgroundColor: Constant.color1,
    borderRadius: 12,
    height: "100%",
  },
  viewCartButtonText: {
    fontWeight: "600",
    fontSize: 18,
    fontFamily: Constant.font,
    color: "#fff",
  },
});
